import TRUNCATE_UNITS from '@/utils/enum/TRUNCATE_UNITS';
import { formatBool } from '@/utils/shared';

const CONTACT_WIDGETS = Object.freeze({
  CONTACT_WIDGETS: [
    {
      id: 'contacts',
      path: 'contacts',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Dashboard.widgets.contacts.headers.company',
          value: 'companyName',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Dashboard.widgets.contacts.headers.name',
          value: 'name',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 15,
        },
        {
          text: 'Dashboard.widgets.contacts.headers.address',
          value: 'address',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20,
        },
        {
          text: 'Dashboard.widgets.contacts.headers.email',
          value: 'email',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 15,
        },
        {
          text: 'Dashboard.widgets.contacts.headers.title',
          value: 'title'
        },
        {
          text: 'Dashboard.widgets.contacts.headers.phone',
          value: 'phone'
        },
        {
          text: 'Dashboard.widgets.contacts.headers.isCompany',
          value: 'isCompany',
          presentWith: formatBool
        },
        {
          text: 'Dashboard.widgets.contacts.headers.position',
          value: 'position'
        },
        {
          text: 'Dashboard.widgets.contacts.headers.internalPosition',
          value: 'internalPosition'
        },
        { text: 'Dashboard.widgets.contacts.headers.aquiseApproach', value: 'aquiseansatz', hide: true },
        { text: 'Dashboard.widgets.contacts.headers.aquiseStatus', value: 'aquisestatus', hide: true }
      ],
      type: 'TABLE',
      moduleId: 'contacts',
      withRouterActionLink: true
    },
    {
      id: 'contactsAmount',
      path: 'contacts',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'contacts'
    }
  ]
});

export default CONTACT_WIDGETS;
